module.exports = __webpack_public_path__ + "fonts/rw-widgets-55e7092.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-widgets/dist/fonts/rw-widgets.svg?v=4.1.0
// module id = 227
// module chunks = 6